module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    staticClass: "gencode"
  }, [_c('domain-select'), _c('div', {
    staticClass: "check-type-select"
  }, [_c('span', [_vm._v("检查代码类型：")]), _vm._l((_vm.ckTypes), function(type, idx) {
    return _c('label', {
      staticClass: "type-label"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "currCkType"
      },
      domProps: {
        "value": idx,
        "checked": _vm.currCkTypeIdx === idx
      },
      on: {
        "change": function($event) {
          _vm.currCkTypeIdx = idx
        }
      }
    }), _c('i'), _c('span', [_vm._v(_vm._s(type.desc))])])
  })], 2), _c('div', {
    staticClass: "page-type-select"
  }, [_c('span', [_vm._v("输入检查页面：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usrUrl),
      expression: "usrUrl"
    }],
    ref: "input",
    staticClass: "size-big",
    attrs: {
      "type": "text",
      "placeholder": "请输入页面URL，如http://fen.360.cn/setting"
    },
    domProps: {
      "value": _vm._s(_vm.usrUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usrUrl = $event.target.value
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "tip": _vm.ckTypes[_vm.currCkTypeIdx].tip,
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "18px"
    }
  })])], 1), _c('div', {
    staticClass: "check-btns"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-medium",
    attrs: {
      "type": "button",
      "value": "开始检查"
    },
    on: {
      "click": _vm.doCheck
    }
  }), _c('a', {
    staticClass: "btn btn-white btn-medium",
    attrs: {
      "href": "/help/manual?target=check",
      "target": "_blank"
    }
  }, [_vm._v("手动检查")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currCkTypeIdx === 0),
      expression: "currCkTypeIdx === 0"
    }],
    staticClass: "ck-tips"
  }, [_vm._m(0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currCkTypeIdx === 1),
      expression: "currCkTypeIdx === 1"
    }],
    staticClass: "ck-tips"
  }, [_c('div', {
    staticClass: "ck-step"
  }, [_vm._v("检查商品、订单、购物车回传代码中的任意代码，都同时会检测基础流量代码，因为基础流量代码是其他代码生效的基础。")]), _vm._m(1), _c('div', {
    staticClass: "ck-step"
  }, [_vm._v("点击“开始检查”，即开始使用360分析模拟登陆输入的商品页面，在后续操作浏览、加入购物车、下单的过程中，因网站技术实现差异，可能存在跳出360分析的情况，跳出后将无法继续监测，建议直接输入检查商品的页面url，减少跳出情况发生。")]), _vm._m(2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currCkTypeIdx === 2),
      expression: "currCkTypeIdx === 2"
    }],
    staticClass: "ck-tips"
  }, [_c('div', {
    staticClass: "ck-step"
  }, [_vm._v("检查注册回传代码中的任意代码，会同时检测基础流量代码，因为基础流量代码是其他代码生效的基础。")]), _vm._m(3), _c('div', {
    staticClass: "ck-step"
  }, [_vm._v("点击“开始检查”，即开始使用360分析模拟登陆开始检查页面，在后操作注册的过程中，因网站技术实现差异，可能存在跳出360分析情况，跳出后将无法继续监测，建议输入检查开始页面直接输入监测注册成功的前一步页面，减少跳出情况发生。")]), _vm._m(4)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ck-step"
  }, [_c('p', [_vm._v("若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ck-example"
  }, [_c('p', [_vm._v("【示例】若您想监测商品回传、订单回传代码：")]), _c('p', [_vm._v("(1) 输入想要检查的商品页面URL；")]), _c('p', [_vm._v("(2) 点击“开始检查”后进入该页面，然后从该页面开始实际进行下单操作流程，直到下单完成，代码检查结果会在页面上直接显示，也可在页面点击返回360分析查看结果。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ck-step"
  }, [_c('p', [_vm._v("若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ck-example"
  }, [_c('p', [_vm._v("【示例】若您想监测注册成功页面：")]), _c('p', [_vm._v("(1) 点击“开始检查”后进入注册流程的开始页；")]), _c('p', [_vm._v("(2) 从该页面开始实际进行注册操作流程，直到注册成功，代码检查结果会在页面上直接显示，也可在页面点击返回360分析查看结果。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ck-step"
  }, [_c('p', [_vm._v("若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-040b40d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-040b40d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/gencode_check.vue
// module id = 706
// module chunks = 0